/**
 * @module 確認ダイアログ共通コンポーネント
 */
export default {
  name: 'ConfirmDialog',
  components: {
    // ContinueDialog,
  },
  props: {
    confirmMessage: {
      type: String,
      default: '',
      require: true,
    },
    confirmDataList: {
      require: false,
    },
    // continueMessage: {
    //   type: String,
    //   default: "",
    //   require: true,
    // },
    mainClick: {
      type: Function,
      require: true,
    },
    closeConfirmDialog: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      message: this.confirmMessage,
      dataList: this.confirmDataList,
      // continueDialog: false,
      // continueDialogMessage: this.continueMessage,
    };
  },
  computed: {},
  /** @type {Methods} */
  methods: {
    /**
     * はいボタン押下時の処理
     */
    updateSettings() {
      this.closeConfirmDialog();
      this.mainClick();
      // this.continueDialog = true;
    },
    // closeDialog() {
    //   this.continueDialog = false;
    // },
  },
};
